import { Time, DatePipe } from "@angular/common";
import { Component, Input } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SelfieViewModalComponent } from "../selfie-view-modal/selfie-view-modal.component";

@Component({
  selector: "app-appointment-item",
  templateUrl: "./appointment-item.component.html",
  styleUrls: ["./appointment-item.component.scss"],
  providers: [DatePipe]
})
export class AppointmentItemComponent {
  @Input() time: Date;
  @Input() hasLatLong: boolean;
  @Input() location?: string;
  @Input() self?: string | null;

  constructor(
    private modalService: NgbModal,
    private datePipe: DatePipe
  ) {}

  openSelfieModal(): void {
    if (!this.self) return;

    const modalRef = this.modalService.open(SelfieViewModalComponent, {
      windowClass: 'selfie-view-modal-container',
      backdrop: true,
      keyboard: true,
      centered: true,
      size: 'md'
    });

    const formattedDate = this.datePipe.transform(this.time, 'dd/MM/yyyy');
    const formattedTime = this.datePipe.transform(this.time, 'HH:mm');
    const dateTimeString = `Foto tirada no dia ${formattedDate} às ${formattedTime}`;

    modalRef.componentInstance.selfieImageBase64 = this.self;
    modalRef.componentInstance.dateTime = dateTimeString;
  }
}
